import "./App.scss";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import Header from "./components/Header/Header";
import EducationPage from "./pages/AboutMe/Education/Education";
import MainInfoPage from "./pages/AboutMe/MainInfo/MainInfo";
import GalleryPage from "./pages/GalleryPage/Gallery";
import QualificationPage from "./pages/AboutMe/Qualification/Qualification";
import FuturePlansPage from "./pages/AboutMe/FuturePlans/FuturePlans";
import UnderConstruction from "./components/common/UnderConstruction/UnderConstruction";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import AboutMePage from "./pages/AboutMe/AboutMePage/AboutMePage";
import SelfPreparation from "./pages/Students/SelfPreparation/SelfPreparation";
import Interests from "./pages/Students/Interests/Interests";
import RecreationAndSportsPage from "./pages/Students/RecreationAndSports/RecreationAndSports";
import PhilosophyPage from "./pages/AboutMe/Philosophy/Philosophy";
import Courses from "./pages/AboutMe/Courses/Courses";

function App() {
  return (
    <div className="App">
      <Header />
      <div className="main-content">
        <div className="main-content__background"></div>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="home" element={<HomePage />} />
          <Route path="about-me">
            <Route index element={<AboutMePage />} />
            <Route path="main-info" element={<MainInfoPage />} />
            <Route path="education" element={<EducationPage />} />
            <Route path="qualification" element={<QualificationPage />} />
            <Route path="courses" element={<Courses />} />
            <Route path="future-plans" element={<FuturePlansPage />} />
            <Route path="philosophy" element={<PhilosophyPage />} />
          </Route>
          <Route path="students">
            <Route index element={<SelfPreparation />} />
            <Route path="self-preparation" element={<SelfPreparation />} />
            <Route path="interests" element={<Interests />} />
            <Route
              path="recreation-and-sports"
              element={<RecreationAndSportsPage />}
            />
          </Route>
          <Route path="gallery">
            <Route index element={<GalleryPage />} />
            <Route path="1-g" element={<GalleryPage startIndex={44} />} />
            <Route
              path="buditeli-24"
              element={<GalleryPage startIndex={40} />}
            />
            <Route
              path="tolerant-24"
              element={<GalleryPage startIndex={43} />}
            />
            <Route
              path="christ-family"
              element={<GalleryPage startIndex={44} />}
            />
            <Route
              path="me-and-my-dad"
              element={<GalleryPage startIndex={45} />}
            />
            <Route
              path="baba-marta"
              element={<GalleryPage startIndex={47} />}
            />
            <Route
              path="dg-zdravec"
              element={<GalleryPage startIndex={49} />}
            />
            <Route path="tarpenie" element={<GalleryPage startIndex={51} />} />
            <Route
              path="prikaznite-geroi"
              element={<GalleryPage startIndex={53} />}
            />
            <Route
              path="earth-day-25"
              element={<GalleryPage startIndex={54} />}
            />
            <Route
              path="bdp-competition"
              element={<GalleryPage startIndex={55} />}
            />
            <Route path="drawings" element={<GalleryPage startIndex={58} />} />
            <Route path="24-may-25" element={<GalleryPage startIndex={62} />} />
            <Route path="4-v-b" element={<GalleryPage startIndex={15} />} />
            <Route path="3-v-b" element={<GalleryPage startIndex={0} />} />
            <Route path="2-v" element={<GalleryPage startIndex={11} />} />
            <Route path="buditeli" element={<GalleryPage startIndex={16} />} />
            <Route path="tolerant" element={<GalleryPage startIndex={18} />} />
            <Route path="bg-artist" element={<GalleryPage startIndex={0} />} />
            <Route
              path="word-day-23"
              element={<GalleryPage startIndex={5} />}
            />
            <Route
              path="earth-day-24"
              element={<GalleryPage startIndex={6} />}
            />
            <Route path="fairy-tail" element={<GalleryPage startIndex={8} />} />
            <Route
              path="christmass-factory"
              element={<GalleryPage startIndex={9} />}
            />
            <Route
              path="earth-day-26"
              element={<GalleryPage startIndex={64} />}
            />
            <Route path="kids-day" element={<GalleryPage startIndex={72} />} />
            <Route path="24-may-26" element={<GalleryPage startIndex={74} />} />
            <Route path="shoko-day" element={<GalleryPage startIndex={76} />} />
            <Route
              path="patiece-day"
              element={<GalleryPage startIndex={77} />}
            />
            <Route
              path="granny-tell-me-story"
              element={<GalleryPage startIndex={80} />}
            />
            <Route
              path="word-day-26"
              element={<GalleryPage startIndex={81} />}
            />
            <Route path="workshop" element={<GalleryPage startIndex={94} />} />
            <Route
              path="sport-week"
              element={<GalleryPage startIndex={102} />}
            />
            <Route path="15-09-25" element={<GalleryPage startIndex={105} />} />
          </Route>
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="attestation" element={<UnderConstruction />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
